import { createContext } from 'react';

export type TransactionsCtx = {
  transactionsSearchStatus: boolean | null;
  transactionsSearchError: string;
  transactionsSuccessMessage: string;
  showTransactionsSearchSuccessAlert: boolean;
  showTransactionsSearchErrorAlert: boolean;
};

const TransactionsContext = createContext<TransactionsCtx>({
  transactionsSearchStatus: false,
  transactionsSearchError: '',
  transactionsSuccessMessage: '',
  showTransactionsSearchSuccessAlert: false,
  showTransactionsSearchErrorAlert: false,
});

export default TransactionsContext;
